module.exports = __webpack_public_path__ + "assets/img/27_1453.cdddba31.jpg";